var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#e5ecf3}.st1{fill:#b2c0cd}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0 0h120v120H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.3 91.3H28.8V28.7c0-2.9 1.8-4.8 4.5-4.8h31.5c2.7 0 4.5 1.9 4.5 4.8v62.6zM93.3 91.3h-21v-39h16.8c2.5 0 4.2 2 4.2 4.9v34.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.8 73.3h-9.5c-1.1 0-2 .9-2 2v16h13.5v-16c0-1.1-.9-2-2-2zM38.3 44.8h8c.3 0 .5.2.5.5v8c0 .3-.2.5-.5.5h-8c-.3 0-.5-.2-.5-.5v-8c0-.2.2-.5.5-.5zM38.3 32.8h8c.3 0 .5.2.5.5v8c0 .3-.2.5-.5.5h-8c-.3 0-.5-.2-.5-.5v-8c0-.2.2-.5.5-.5zM51.8 44.8h8c.3 0 .5.2.5.5v8c0 .3-.2.5-.5.5h-8c-.3 0-.5-.2-.5-.5v-8c0-.2.2-.5.5-.5zM78.8 59.8h8c.3 0 .5.2.5.5v8c0 .3-.2.5-.5.5h-8c-.3 0-.5-.2-.5-.5v-8c0-.2.2-.5.5-.5zM51.8 32.8h8c.3 0 .5.2.5.5v8c0 .3-.2.5-.5.5h-8c-.3 0-.5-.2-.5-.5v-8c0-.2.2-.5.5-.5zM38.3 56.8h8c.3 0 .5.2.5.5v8c0 .3-.2.5-.5.5h-8c-.3 0-.5-.2-.5-.5v-8c0-.2.2-.5.5-.5zM51.8 56.8h8c.3 0 .5.2.5.5v8c0 .3-.2.5-.5.5h-8c-.3 0-.5-.2-.5-.5v-8c0-.2.2-.5.5-.5zM78.8 71.8h8c.3 0 .5.2.5.5v8c0 .3-.2.5-.5.5h-8c-.3 0-.5-.2-.5-.5v-8c0-.2.2-.5.5-.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.6 88.3h69c1.2 0 2.2 1 2.2 2.2 0 1.2-1 2.2-2.2 2.2h-69c-1.2 0-2.2-1-2.2-2.2-.1-1.2.9-2.2 2.2-2.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyAvatar);
export default __webpack_public_path__ + "static/media/company-avatar.1b987c6b25d0e1c31acde3476f032a50.svg";
export { ForwardRef as ReactComponent };